module.exports = __webpack_public_path__ + "img/todayActive.ac6e66c3.png";